import {
  useInitializeZoomSettings,
  useSubscribeToZoomSettings,
} from "../hooks/useZoomSettings";
import {
  useInitializeZoomNotification,
  useSubscribeToZoomNotification,
} from "../hooks/home/tabs/dashboard/components/useZoomNotification";

const ZoomSettingsInitializer = () => {
  // Zoom Settings 초기화
  useInitializeZoomSettings();
  useSubscribeToZoomSettings();

  // Zoom Notification 초기화
  useInitializeZoomNotification();
  useSubscribeToZoomNotification();

  // 이 컴포넌트는 UI를 렌더링하지 않음
  return null;
};

export default ZoomSettingsInitializer;
